import { Api, ENCRYPT_STORAGE } from "../../config/config";
import { dto_Customer } from "../../classes/dto-customer";
import { postMethod } from "../post";
import { dto_common } from "../../classes/dto-common";
import { ENTRY_MODE } from "../../database/store-names";

export const api_LoadProductToPID = (MID, PID) => {
  let entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
  let IsERP = false;
  if (entryMode === "QR") {
    IsERP = true;
  }

  var url = `${Api}/?ControllerName104=/ApiHome`;
  return postMethod(
    url,
    '{"SERVICENAME":"LoadProductToPID","CSID":' +
      dto_Customer.CSID +
      ',"ZONEID":' +
      dto_common.ZoneId +
      ',"MTYPE":"' +
      dto_common.MTYPE +
      '","PID":' +
      PID +
      ',"MID":' +
      MID +
      ',"CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '","NIC":"' +
      dto_Customer.NIC +
      '","IsERP":"' +
      IsERP +
      '"}',
  );
};
